import UrlParserService from '@/modules/register/modules/RegistrationPage/services/url-parser.service';
import { httpClient } from '@/shared/services/httpClient';
import { ILoginParams } from './auth-service.types';

const RAINBOW_API = '/api/v1/auth';
const LOGIN_URL = `${RAINBOW_API}/login`;
const { organizationSubdomain } = UrlParserService.parse({});

export const login = (params: ILoginParams) => httpClient.baseClientSilent.post(
  LOGIN_URL,
  {
    userId: params.userId,
    kfactor: params.sykValue,
    cfactor: params.pinCode,
    subdomain: organizationSubdomain,
  },
);
